module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/about_image_web_sp-06abe42b60cc8c1f76897d20b42566ea.jpg";